import { render, staticRenderFns } from "./item-card.vue?vue&type=template&id=31ccbf81&scoped=true"
import script from "./item-card.vue?vue&type=script&lang=js"
export * from "./item-card.vue?vue&type=script&lang=js"
import style0 from "./item-card.vue?vue&type=style&index=0&id=31ccbf81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ccbf81",
  null
  
)

export default component.exports